import { createSlice } from "@reduxjs/toolkit";
import { fetchInsightsAsync } from "../insights/insightsSlice.js";
import {
  fetchFocusedInterview,
  fetchNonEmptyInterviewsForProject,
} from "../interviews/interviewsSlice.js";
import { contactsAdapter } from "./contactsState.js";

const initialState = contactsAdapter.getInitialState<{
  status: "idle" | "loading" | "succeeded" | "failed";
  error: string | null;
}>({
  status: "idle",
  error: null,
});

const contactSlice = createSlice({
  name: "contacts",
  initialState,
  reducers: {
    contactAdded: contactsAdapter.addOne,
    contactsAdded: contactsAdapter.addMany,
    contactRemoved: contactsAdapter.removeOne,
    contactUpdated: contactsAdapter.updateOne,
  },
  extraReducers: (builder) => {
    builder.addCase(
      fetchNonEmptyInterviewsForProject.fulfilled,
      (state, action) => {
        state.status = "succeeded";
        // This thunk is in the interviewsSlice but creates both contacts
        // and interviews, so we handle updating contact state here.
        contactsAdapter.addMany(state, action.payload.contacts);
      },
    );
    builder.addCase(fetchFocusedInterview.fulfilled, (state, action) => {
      contactsAdapter.upsertOne(state, action.payload.contact);
    });
    builder.addCase(fetchInsightsAsync.fulfilled, (state, action) => {
      contactsAdapter.addMany(state, action.payload.contacts);
    });
  },
});

export const { contactAdded, contactsAdded, contactRemoved, contactUpdated } =
  contactSlice.actions;
export default contactSlice.reducer;
